import { chartRelatedReportTypes } from "../../../../reporting/sv/utilities/chartRelatedReport.types.ts";
import type {
  AnyReportConfigurationForRunning,
  ChartReportConfigurationForRunning,
  PivotReportConfigurationForRunning,
  TabularReportConfigurationForRunning,
  TileReportConfigurationForRunning,
} from "../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../api/types/svTypes.ts";

export const isTabularReportConfiguration = (
  reportConfiguration: AnyReportConfigurationForRunning
): reportConfiguration is TabularReportConfigurationForRunning => {
  return reportConfiguration.reportType === ReportType.Tabular;
};

export const isPivotReportConfiguration = (
  reportConfiguration: AnyReportConfigurationForRunning
): reportConfiguration is PivotReportConfigurationForRunning => {
  return reportConfiguration.reportType === ReportType.Pivot;
};

export const isChartReportConfiguration = (
  reportConfiguration: AnyReportConfigurationForRunning
): reportConfiguration is ChartReportConfigurationForRunning => {
  return chartRelatedReportTypes.includes(reportConfiguration.reportType);
};

export const isTileReportConfiguration = (
  reportConfiguration: AnyReportConfigurationForRunning
): reportConfiguration is TileReportConfigurationForRunning => {
  return reportConfiguration.reportType === ReportType.Tile;
};
